import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { dateTolocale } from 'utils/converter';

const textColor = '#393939';
const primaryBlue = '#05164D';
const borderColor = primaryBlue;

const cellProperties = {
  padding: 2,
  paddingLeft: 4,
  fontSize: 8,
  color: textColor,
  alignSelf: 'stretch', 
  whiteSpace: 'break-spaces',
  fontFamily: 'NunitoRegular',
  borderRightColor: borderColor,
  borderRightWidth: 1,
};
const headProperties = {
  paddingRight: 5,
  paddingLeft: 5,
  fontSize: 8,
  color: 'white',
  textTransform: 'uppercase',
  whiteSpace: 'break-spaces',
  fontFamily: 'NunitoMedium',
};

const styles = StyleSheet.create({
  headerContainer: { marginTop: 24 },
  label: {
    fontSize: 10,
    paddingBottom: 3,
    lineHeight: 'normal',
  },
  title: {
    fontSize: 9,
    textTransform: 'uppercase',
    backgroundColor: '#f0f0f0',
    color: primaryBlue,
    padding: '4px 35px',
    textAlign: 'center',
    marginBottom: 5,
    lineHeight: 'normal',
    fontFamily: 'NunitoMedium',
    borderBottom: `2px solid ${primaryBlue}`,
  },
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 10,
    marginBottom: 20,
  },
  container: {
    flexDirection: 'row',
    padding: '4px 2px',
    backgroundColor: primaryBlue,
    alignItems: 'center',
    flexGrow: 1,
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    minHeight: 16,
  },
  altRow: { backgroundColor: '#f5f5f5', },
  header20: {
    ...headProperties,
    width: '20%',
  },
  cell20: {
    ...cellProperties,
    width: '20%',
  },
  header30: {
    ...headProperties,
    width: '30%',
  },
  cell30: {
    ...cellProperties,
    width: '30%',
  },
  noDataRow: {
    fontSize: 9,
    width: '100%',
    textAlign: 'center',
    padding: 4,
    color: textColor,
    fontFamily: 'NunitoRegular',
    borderColor: borderColor,
    borderWidth: 1,
  },
});

const FlightHistory = (props) => {
  const { history } = props;

  return (
    <>
      <View style={styles.headerContainer}>
        <Text style={styles.title}>History</Text>
        
        <View style={styles.tableContainer} wrap={true}>
          <View style={styles.container}>
            <View style={styles.header20}><Text>Date & Time</Text></View>
            <View style={styles.header20}><Text>Type</Text></View>
            <View style={styles.header30}><Text>Details</Text></View>
            <View style={styles.header30}><Text>User</Text></View>
          </View>

          {history && history.length > 0 ?
            history?.map((item, i) =>
              <View style={[
                styles.tableRow,
                i % 2 === 1 && styles.altRow // Apply altRow to odd rows
              ]} key={item.id}>
                <View style={styles.cell20}><Text>{dateTolocale(item.created, 'DD MMM YYYY HH:mm')?.toUpperCase()}</Text></View>
                <View style={styles.cell20}><Text>{item.type}</Text></View>
                <View style={styles.cell30}><Text>{item.operation_desc}</Text></View>
                <View style={styles.cell30}><Text>{item?.user?.first_name + ' ' + item?.user?.last_name + ` (${item?.user?.role})`}</Text></View>
              </View>
            ) : <View  style={styles.noDataRow}>
              <Text>No Data</Text>
            </View>}

        </View>
      </View>

    </>
  );
};
  
export default FlightHistory;